import { render, staticRenderFns } from "./BottomRightArea.vue?vue&type=template&id=139c2fae&scoped=true"
import script from "./BottomRightArea.vue?vue&type=script&lang=js"
export * from "./BottomRightArea.vue?vue&type=script&lang=js"
import style0 from "./BottomRightArea.vue?vue&type=style&index=0&id=139c2fae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c2fae",
  null
  
)

export default component.exports